function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.063,
    height: 13.063,
    viewBox: "0 0 13.063 13.063",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "icon/image",
    d: "M19312.617 22998.887a1.616 1.616 0 0 1-1.615-1.615v-8.832a1.612 1.612 0 0 1 1.615-1.615h8.826a1.612 1.612 0 0 1 1.615 1.615v7.572a.252.252 0 0 1 0 .094v1.166a1.616 1.616 0 0 1-1.615 1.615zm2.314-4.588-3.006 2.521v.451a.691.691 0 0 0 .691.686h8.826a.688.688 0 0 0 .688-.686v-.988l-1.83-1.471a.316.316 0 0 0-.375 0l-1.461 1.131a1.239 1.239 0 0 1-1.615-.109l-1.5-1.535a.3.3 0 0 0-.207-.078.309.309 0 0 0-.21.079zm-3.006-5.859v7.168l2.406-2.031a1.247 1.247 0 0 1 1.674.07l1.5 1.5a.3.3 0 0 0 .4 0l1.455-1.057a1.248 1.248 0 0 1 1.512 0l1.254 1v-6.654a.686.686 0 0 0-.687-.687h-8.826a.689.689 0 0 0-.687.69zm5.258 2.563a1.7 1.7 0 1 1 1.7 1.7 1.7 1.7 0 0 1-1.699-1.703zm.93 0a.773.773 0 1 0 .773-.773.771.771 0 0 0-.773.77z",
    transform: "translate(-19310.502 -22986.324)",
    style: {
      fill: "#082042",
      stroke: "transparent",
      strokeMiterlimit: 10
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconImage);
export default __webpack_public_path__ + "static/media/icon-image.f7ed4bd0393d32e5ace0d15a0ce296e4.svg";
export { ForwardRef as ReactComponent };